'use strict';

var slicedToArray = require('../../../../node_modules/@babel/runtime/helpers/slicedToArray.js');
var objectWithoutProperties = require('../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var withStyles = require('../../../Styles/withStyles.js');
var FloatingActionButton = require('../../../Inputs/Buttons/FloatingActionButton.js');
var ListItemText = require('../../../DataDisplay/List/ListItemText.js');
var Divider = require('../../../DataDisplay/Divider/Divider.js');
var Avatar = require('../../../DataDisplay/Avatar/Avatar.js');
var ExitToApp = require('../../../../IconsAndImages/Icons/ExitToApp.js');
var Settings = require('../../../../IconsAndImages/Icons/Settings.js');
var Tasks = require('../../../../IconsAndImages/Icons/Tasks.js');
var Chat = require('../../../../IconsAndImages/Icons/Chat.js');
var Call = require('../../../../IconsAndImages/Icons/Call.js');
var ActivityFeed = require('../../../../IconsAndImages/Icons/ActivityFeed.js');
var TruncateText = require('../../../../utils/TruncateText.js');
var Popover = require('../../../../node_modules/@material-ui/core/esm/Popover/Popover.js');
var MenuList = require('../../../../node_modules/@material-ui/core/esm/MenuList/MenuList.js');
var List = require('../../../../node_modules/@material-ui/core/esm/List/List.js');
var ListItem = require('../../../../node_modules/@material-ui/core/esm/ListItem/ListItem.js');
var ListItemIcon = require('../../../../node_modules/@material-ui/core/esm/ListItemIcon/ListItemIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    listPadding: {
      maxWidth: 300,
      paddingTop: 0,
      '&:focus': {
        outline: 'none'
      }
    },
    proListItem: {
      background: theme.palette.brandPrimary.main
    },
    avatarButtonStyle: {
      boxShadow: 'none',
      marginLeft: 12
    },
    avatarStyle: {
      width: 40,
      height: 40,
      borderRadius: '50%',
      border: '1px solid #e0e0e0'
    }
  };
};

var ProAvatar = function ProAvatar(_ref) {
  var classes = _ref.classes,
      pro = _ref.pro,
      showTasks = _ref.showTasks,
      showActivity = _ref.showActivity,
      showChat = _ref.showChat,
      showCalls = _ref.showCalls;
      objectWithoutProperties(_ref, ["classes", "pro", "showTasks", "showActivity", "showChat", "showCalls"]);

  var _useState = React.useState(false),
      _useState2 = slicedToArray(_useState, 2),
      proAvatarMenuOpen = _useState2[0],
      setProAvatarMenuOpen = _useState2[1];

  var _useState3 = React.useState(null),
      _useState4 = slicedToArray(_useState3, 2),
      proAvatarMenuAnchor = _useState4[0],
      setProAvatarMenuAnchor = _useState4[1];

  var handleProAvatarMenuOpen = function handleProAvatarMenuOpen(event, open) {
    setProAvatarMenuAnchor(event.currentTarget);
    setProAvatarMenuOpen(open);
  };

  return React__default["default"].createElement(React.Fragment, null, React__default["default"].createElement(FloatingActionButton, {
    onClick: function onClick(event) {
      return handleProAvatarMenuOpen(event, true);
    },
    size: "small",
    classes: {
      root: classes.avatarButtonStyle
    }
  }, React__default["default"].createElement("img", {
    src: pro.logo_url,
    className: classes.avatarStyle
  }), pro.logo_url ? null : pro.name.slice(0, 1)), React__default["default"].createElement(Popover["default"], {
    open: proAvatarMenuOpen,
    anchorEl: proAvatarMenuAnchor,
    anchorReference: "anchorEl",
    onClose: function onClose(event) {
      handleProAvatarMenuOpen(event, false);
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, React__default["default"].createElement(MenuList, {
    className: classes.listPadding
  }, React__default["default"].createElement(List["default"], {
    component: "nav",
    className: classes.listPadding
  }, React__default["default"].createElement(ListItem["default"], {
    key: 'a',
    onClick: function onClick() {
    },
    className: classes.proListItem
  }, React__default["default"].createElement(ListItemIcon["default"], null, React__default["default"].createElement(Avatar, {
    src: pro.logo_url
  }, pro.logo_url ? null : pro.name.slice(0, 1))), React__default["default"].createElement(ListItemText, {
    primary: pro.name,
    style: {
      color: '#fff'
    },
    primaryTypographyProps: {
      color: 'inherit'
    },
    secondary: React__default["default"].createElement(TruncateText, {
      maxLines: 1
    }, pro.email),
    secondaryTypographyProps: {
      color: 'inherit'
    }
  })), React__default["default"].createElement(Divider, null), showChat && React__default["default"].createElement(ListItem["default"], {
    button: true,
    key: 'c',
    onClick: function onClick() {
    }
  }, React__default["default"].createElement(ListItemIcon["default"], null, React__default["default"].createElement(Chat, null)), React__default["default"].createElement(ListItemText, {
    primary: "Chat"
  })), showCalls && React__default["default"].createElement(ListItem["default"], {
    button: true,
    key: 'c',
    onClick: function onClick() {
    }
  }, React__default["default"].createElement(ListItemIcon["default"], null, React__default["default"].createElement(Call, null)), React__default["default"].createElement(ListItemText, {
    primary: "Calls"
  })), showTasks && React__default["default"].createElement(ListItem["default"], {
    button: true,
    key: 'c',
    onClick: function onClick() {
    }
  }, React__default["default"].createElement(ListItemIcon["default"], null, React__default["default"].createElement(Tasks, null)), React__default["default"].createElement(ListItemText, {
    primary: "Tasks"
  })), showActivity && React__default["default"].createElement(ListItem["default"], {
    button: true,
    key: 'c',
    onClick: function onClick() {
    }
  }, React__default["default"].createElement(ListItemIcon["default"], null, React__default["default"].createElement(ActivityFeed, null)), React__default["default"].createElement(ListItemText, {
    primary: "Activity"
  })), React__default["default"].createElement(Divider, null), React__default["default"].createElement(ListItem["default"], {
    button: true,
    key: 'b',
    onClick: function onClick() {
    }
  }, React__default["default"].createElement(ListItemIcon["default"], null, React__default["default"].createElement(Settings, null)), React__default["default"].createElement(ListItemText, {
    primary: "Account settings"
  })), React__default["default"].createElement(ListItem["default"], {
    button: true,
    key: 'd',
    onClick: function onClick() {
    }
  }, React__default["default"].createElement(ListItemIcon["default"], null, React__default["default"].createElement(ExitToApp, null)), React__default["default"].createElement(ListItemText, {
    primary: "Logout"
  }))))));
};

var ProAvatar$1 = withStyles["default"](styles)(ProAvatar);

module.exports = ProAvatar$1;
